import { render, staticRenderFns } from "./ChatFileUpload.vue?vue&type=template&id=3aa73d50&scoped=true"
import script from "./ChatFileUpload.vue?vue&type=script&lang=js"
export * from "./ChatFileUpload.vue?vue&type=script&lang=js"
import style0 from "./ChatFileUpload.vue?vue&type=style&index=0&id=3aa73d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa73d50",
  null
  
)

export default component.exports